import { type PropsWithChildren } from "react";

type Props = {
  kpiTypeDisplayName: string;
  formatValueApproximate: (value: number) => string;
  predictedValues: {
    low: number;
    median: number;
    high: number;
  } | null;
};

export const PredictedValueRangeCard = ({
  predictedValues,
  kpiTypeDisplayName,
  formatValueApproximate,
  children,
}: PropsWithChildren<Props>) => {
  if (!predictedValues) {
    return null;
  }

  return (
    <div className="border h-16 rounded-lg flex items-center justify-between p-3 basis-1/3">
      <div className="font-semibold leading-4">
        <div>Predicted</div>
        <div>{kpiTypeDisplayName}</div>
      </div>
      <div className="flex gap-0.5 items-center h-5">
        <span className="text-xs">
          {formatValueApproximate(predictedValues.low)}
        </span>
        <div className="bg-gradient-to-r from-mars to-sun min-w-[16px] h-1 rounded-sm" />
        <div className="text-cosmic font-semibold relative">
          {formatValueApproximate(predictedValues.median)}
          <div className="absolute-horizontal-center -bottom-2 text-2xs text-gray+1">
            Median
          </div>
        </div>
        <div className="bg-gradient-to-r from-sun to-alien min-w-[16px] h-1 rounded-sm" />
        <span className="text-xs">
          {formatValueApproximate(predictedValues.high)}
        </span>
      </div>
      {children}
    </div>
  );
};
